module.exports = __webpack_public_path__ + "379e3766cc4f20400599de63b01b7ce0.pdf";